import gql from "graphql-tag";

export const MY_HR_SEND_EMAIL_2FA_CODE = gql`
  mutation sendEmail2faCode($email: String!, $locale: String!) {
    sendEmail2faCode(email: $email, locale: $locale)
  }
`;
